<template lang="pug">
  v-container.pa-5
    div.h5.primary--text {{ $t('whos_selling') }}
    div.p1.basic700--text.mt-4 {{ $t('assign_sales_team') }}

    template(v-if="form.members && form.members.length > 0")
      v-select.mt-6(v-model="form.members" background-color="basic200" outlined dense hide-no-data chips hide-details multiple readonly :items="form.members" :menu-props="({'closeOnContentClick': false})" placeholder="Add Members" ref="selectMembers" type="button" append-icon="")
        template(v-slot:selection="{ attrs, item, select, selected }")
          v-chip.s2.my-1(:style="`background-color: ${$vuetify.theme.themes[$theme].basic600T08}`" v-bind="attrs" outlined small close :color="item.status === 'inactive' ? 'danger' : 'basic600'" :input-value="selected" @click:close="removeMember(item)" close-icon="mdi-close")
            span {{ item.user.first_name }} {{ item.user.last_name }}{{ item.status === 'inactive' ? ' (inactive)' : '' }}
      
      v-btn.button-Aa-small.mt-2(color="info500" text x-small height="30" @click="showAttachMembersDialog = true")
        v-icon.mr-1(small) mdi-plus
        | {{ $t('add_member') }}
    
    div.d-flex.align-center.mt-6(v-else style="height: 40px; border:1px solid var(--v-basic400); border-radius: 4px;")
      v-btn.button-Aa-small(color="info500" text x-small height="30" @click="showAttachMembersDialog = true")
        v-icon.mr-1(small) mdi-plus
        | {{ $t('attach_member') }}

    .modals
      attach-members(v-if="showAttachMembersDialog" :open.sync="showAttachMembersDialog" :initialMembers.sync="form.members")
      
</template>

<script>
import AttachMembers from '@/components/dialogs/AttachMembers.vue'

export default {
  name: 'LandingSalesPerson',
  props: ['parentForm', 'company'],
  components: { AttachMembers },
  data: () => ({
    showAttachMembersDialog: false,
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)',
      padding: '16px'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
      padding: '17px'
    }
  }),
  computed: {
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    },
  },
  methods: {
    removeMember (item) {
      let index = this.form.members.map(m => { return m.id}).indexOf(item.id)
      if (index >= 0) this.form.members.splice(index, 1)
      this.$refs.selectMembers.isMenuActive = false
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "whos_selling": "Who’s selling?",
    "assign_sales_team": "Assign sales team members responsible for leads coming from this sales page."
  },
  "id": {
    "whos_selling": "Penjual",
    "assign_sales_team": "Tetapkan anggota tim penjualan yang bertanggung jawab atas leads yang berasal dari halaman penjualan ini."
  }
}
</i18n>